import { BooleanInput, Datagrid, FunctionField, List, ReferenceField, Resource } from "react-admin";
import { MoneyField } from "../fields/MoneyField";
import { restrictAccessToDrivingSchoolIds } from "../backoffice.access_control";
import { ReferenceDrivingSchoolField } from "../fields/ReferenceDrivingSchoolField";
import { BackofficeListTitle } from "../misc/BackofficeListTitle";
import { EmptyState } from "../misc/EmptyState";

export const invoiceCustomersResource = (
  <Resource
    key="invoiceCustomers"
    name="invoiceCustomers"
    list={InvoiceCustomersList}
    options={{ label: "Rechnungskunden" }}
  />
);

export function InvoiceCustomersDatagrid(props: { showDrivingSchool?: boolean; hideAktivPrefix?: boolean }) {
  const { showDrivingSchool, hideAktivPrefix } = props;
  return (
    <Datagrid
      rowClick={(studentId) => `/students/${studentId}/invoices`}
      bulkActionButtons={false}
      empty={
        <EmptyState
          noEntriesText="Noch kein Rechnungskunde hinterlegt."
          noMatchingEntriesText="Keine passenden Rechnungskunden gefunden."
        />
      }
    >
      <ReferenceField label="Fahrschüler" reference="students" source="id" />
      {showDrivingSchool && <ReferenceDrivingSchoolField label="Fahrschule" source="drivingSchoolId" link />}
      <FunctionField
        label="Status"
        source="verboseStatus"
        render={(record: { verboseStatus?: string }) =>
          hideAktivPrefix && record.verboseStatus?.startsWith("Aktiv") ? "Aktiv" : record.verboseStatus
        }
      />
      <MoneyField label="Betrag offene Rechnungen" source="sumUnpaidInvoices" />
      <MoneyField label="Summe bezahlte Rechnungen" source="sumPaidInvoices" />
      <MoneyField label="Budget" source="budget" />
      <MoneyField label="restliches Budget" source="remainingBudget" redForNegativeValues />
    </Datagrid>
  );
}

function InvoiceCustomersList() {
  return (
    <List
      title={<BackofficeListTitle />}
      filter={
        restrictAccessToDrivingSchoolIds?.length === 1
          ? { drivingSchoolId: restrictAccessToDrivingSchoolIds[0] }
          : undefined
      }
      filters={[<BooleanInput source="includeArchivedStudents" label="Zeige auch archivierte Fahrschüler" alwaysOn />]}
      exporter={false}
    >
      <InvoiceCustomersDatagrid showDrivingSchool />
    </List>
  );
}
